import { Api } from '@trellis/api'

import { env } from '@/env.js'
import { handleSuspendedTenantResponse } from '@/lib/suspended-tenant'
import { getStoredTenantSlug } from '@/lib/tenant'

/*
 * Wrap the Api instance under `.api` so callers use `apiClient.api.xxx`,
 * matching the pattern enforced across all request registry files.
 *
 * X-Tenant-Slug is injected per-request via customFetch so the header
 * reflects the currently selected tenant (stored in localStorage).
 */
const instance = new Api({
  baseUrl: env.VITE_API_BASE_URL,
  baseApiParams: {
    redirect: 'follow',
    referrerPolicy: 'no-referrer',
    format: 'json',
  },
  customFetch: async (url, init) => {
    const tenantSlug = getStoredTenantSlug()
    const headers = new Headers(init?.headers)
    if (tenantSlug) headers.set('X-Tenant-Slug', tenantSlug)
    /*
     * The API sets Cache-Control: max-age=60 on GET responses for browsers that
     * navigate directly to a JSON endpoint. TanStack Query already owns request
     * caching/staleTime for app traffic, so bypass the HTTP cache here — otherwise
     * a query-invalidation refetch can be silently served a stale cached response.
     */
    const response = await fetch(url, {
      ...init,
      headers,
      credentials: 'include',
      cache: 'no-store',
    })
    await handleSuspendedTenantResponse(response)
    return response
  },
})

export const apiClient = { api: instance }
